export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const REGISTER_BUSINESS_REQUEST = 'REGISTER_BUSINESS_REQUEST';
export const GENERATE_OTP = 'GENERATE_OTP';
export const BUSINESS_STARTS_REQUEST = 'BUSINESS_STARTS_REQUEST';
export const BUSINESS_SALES_REQUEST = 'BUSINESS_SALES_REQUEST';
export const RESEND_VERIFICATION_EMAIL = 'RESEND_VERIFICATION_EMAIL';
export const LOAD_RESET_PASSWORD = 'LOAD_RESET_PASSWORD';
export const SEND_RESET_PASSWORD = 'SEND_RESET_PASSWORD';
export const LOAD_PREPARE_ENCRYPTION = 'LOAD_PREPARE_ENCRYPTION';
export const SET_PREPARE_ENCRYPTION = 'SET_PREPARE_ENCRYPTION';
